import { supabase } from "@/integrations/supabase/client";

interface StripePaymentMetadata {
  travel_request_id: string; // UUID
  user_id: string; // UUID
  itinerary_id: string; // UUID
  customer_email?: string | null;
}

interface CreateStripePaymentLinkParams {
  itineraryId: string;
  travelRequestId: string;
  itineraryTitle: string;
  itineraryTotal?: number | null;
  userId: string; // UUID
  customerEmail?: string | null; // solo per email, non per metadata
}

export const createStripePaymentLink = async ({
  itineraryId,
  travelRequestId,
  itineraryTitle,
  itineraryTotal,
  userId,
  customerEmail,
}: CreateStripePaymentLinkParams): Promise<string> => {
  // Costruisci metadata Stripe con solo UUID
  const metadata: StripePaymentMetadata = {
    travel_request_id: travelRequestId,
    user_id: userId,
    itinerary_id: itineraryId,
    customer_email: customerEmail ?? null,
  };

  console.log("Creating Stripe payment link with metadata:", metadata);

  const payload = {
    line_items: [
      {
        price_data: {
          currency: "eur",
          product_data: {
            name: itineraryTitle,
            description: "Place2Be Trip Quote",
          },
          unit_amount: Math.round((Number(itineraryTotal) || 0) * 100),
        },
        quantity: 1,
      },
    ],
    metadata,
  };

  const { data, error } = await supabase.functions.invoke("create-stripe-link", {
    body: payload,
  });

  if (error) {
    throw new Error(error.message);
  }

  const stripeData = data as { url?: string } | null;
  if (!stripeData?.url) {
    throw new Error("Stripe payment link was not returned");
  }

  return stripeData.url;
};